<template>
  <div v-if="community !== undefined">
    <div
      v-if="community.type === 'public'"
      class="action-block lined-block"
    >
      <p v-if="!community.isBroadcast">
        {{ $t('community.joinCommunity.joinThisCommunity') }}
      </p>
      <p v-else>
        {{ $t('community.joinCommunity.joinThisBroadcast') }}
      </p>
      <v-button
        :on-click="join"
        :is-loading="loading"
        class="button"
      >
        {{ $t('community.joinCommunity.join') }}
      </v-button>
    </div>
    <div
      v-else-if="hasPendingJoinRequest"
      class="action-block lined-block"
    >
      <p>{{ $t('community.joinCommunity.joinRequestSent') }}</p>
    </div>
    <div
      v-else
      class="action-block lined-block"
    >
      <p>{{ $t('community.joinCommunity.joinPrivateCommunity') }}</p>
      <div class="button-container">
        <v-button :on-click="joinRequest">
          {{ $t('community.joinCommunity.sendRequest') }}
        </v-button>
      </div>
    </div>
  </div>
</template>
<script>

import VButton from '@/components/shared/VButton'

export default {
  name: 'JoinCommunity',
  components: { VButton },
  props: {
    community: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showModal: false,
      loading: false
    }
  },
  methods: {
    async join () {
      if (this.community.type !== 'private') {
        this.loading = true
        await this.$store.dispatch('joinCommunity', this.community.id)
        this.loading = false
      }
    },
    async joinRequest () {
      await this.$store.dispatch('addJoinRequest', this.community.id)
    },
    hasCommunityAccess () {
      if (this.community.type.toLowerCase() === 'private') {
        return this.$store.getters.userCommunities.includes(this.community.id)
      }
      return true
    }
  },
  computed: {
    hasPendingJoinRequest () {
      return this.$store.getters.userJoinRequests.find(joinRequest => joinRequest.idCommunity === this.community.id) !== undefined
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.action-block {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 606px;
  max-width: calc(100% - 2rem);
  @media (max-width: $medium) {
    width: calc(50vw - 32px);

  }
  @media (max-width: $header-change) {
    margin: 0.5rem !important;
    width: calc(80vw);
    max-width: none !important;

  }
  @media (max-width: $small) {
    width: calc(100vw - 1rem);

  }

  p {
    margin: 16px 24px;
  }
}

.button {
    margin: 22px 24px;
}

.lined-block {
    background: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
    border-radius: 3px;
    margin: 1rem;
    border-top: solid 2px $secondary-color;
    text-align: left;
    color: $black-color;
    letter-spacing: 0;
    line-height: 24px;
    .button-container {
      margin: 1rem;
    }
}
</style>
